import { defineMessages } from '../define';
import { plural } from '..';

/** Главный экран: конверты и ближайшие платежи. */
export const pagesEnvelopes = defineMessages({
  ru: {
    'envelopesPage.title': 'Бюджет',
    'envelopesPage.emptyTitle': 'Конвертов пока нет',
    'envelopesPage.emptyDesc': 'Конверт: категория с лимитом на период, например «Продукты», «Деревня», «Развлечения».',
    'envelopesPage.emptyAction': 'Завести первый конверт',
    'envelopesPage.envelopes': 'Конверты',
    'envelopesPage.paceMark': 'где должен быть остаток',
    'envelopesPage.noCategoryAdd': 'Без категории: добавить трату',
    'envelopesPage.noCategoryOpen': 'Открыть: без категории',
    'envelopesPage.newEnvelope': 'Новый конверт',
    'envelopesPage.perDay': 'Можно тратить в день',
    'envelopesPage.over': 'Перерасход',
    'envelopesPage.left': 'Осталось',
    'envelopesPage.overShort': 'перерасход',
    'envelopesPage.leftShort': 'осталось',
    'envelopesPage.spentShort': 'потрачено',
    'envelopesPage.daysAhead': (p: { n: number }) => plural(p.n, { one: 'день впереди', few: 'дня впереди', many: 'дней впереди', other: 'дня впереди' }),
    'envelopesPage.limitShort': 'лимит',
    'envelopesPage.ahead': (p: { spent: number; days: number }) => `Траты обгоняют период: ушло ${p.spent}% бюджета за ${p.days}% дней.`,
    'envelopesPage.soon': 'Скоро платить',
    'envelopesPage.allPayments': 'Все платежи',
    'envelopesPage.paidToast': (p: { name: string }) => `«${p.name}» оплачен`,
    'envelopesPage.undo': 'Отменить',
    'envelopesPage.markFailed': (p: { error: string }) => `Не удалось отметить: ${p.error}`,
    'envelopesPage.more': (p: { n: number }) => `ещё ${p.n}`,
    'envelopesPage.today': 'сегодня',
    'envelopesPage.tomorrow': 'завтра',
    'envelopesPage.overdueBy': (p: { n: number }) => `просрочен на ${p.n} ${plural(p.n, { one: 'день', few: 'дня', many: 'дней', other: 'дня' })}`,
    'envelopesPage.markPaid': (p: { name: string }) => `Отметить «${p.name}» оплаченным`,
    'envelopesPage.addTo': (p: { name: string }) => `${p.name}: добавить трату`,
    'envelopesPage.tileOver': (p: { limit: string }) => `перерасход · лимит ${p.limit}`,
    'envelopesPage.tileLeft': (p: { limit: string }) => `осталось из ${p.limit}`,
    'envelopesPage.tileNoLimit': 'потрачено · без лимита',
    'envelopesPage.open': (p: { name: string }) => `Открыть конверт «${p.name}»`,
    'envelopesPage.loading': 'Загрузка',
  },
  en: {
    'envelopesPage.title': 'Budget',
    'envelopesPage.emptyTitle': 'No envelopes yet',
    'envelopesPage.emptyDesc': 'An envelope is a category with a limit per period, like "Groceries", "Country house", "Fun".',
    'envelopesPage.emptyAction': 'Create first envelope',
    'envelopesPage.envelopes': 'Envelopes',
    'envelopesPage.paceMark': 'where the balance should be',
    'envelopesPage.noCategoryAdd': 'Uncategorized: add expense',
    'envelopesPage.noCategoryOpen': 'Open: uncategorized',
    'envelopesPage.newEnvelope': 'New envelope',
    'envelopesPage.perDay': 'You can spend per day',
    'envelopesPage.over': 'Overspent',
    'envelopesPage.left': 'Left',
    'envelopesPage.overShort': 'overspent',
    'envelopesPage.leftShort': 'left',
    'envelopesPage.spentShort': 'spent',
    'envelopesPage.daysAhead': (p: { n: number }) => plural(p.n, { one: 'day left', other: 'days left' }),
    'envelopesPage.limitShort': 'limit',
    'envelopesPage.ahead': (p: { spent: number; days: number }) => `Spending is ahead of the period: ${p.spent}% of the budget is gone in ${p.days}% of the days.`,
    'envelopesPage.soon': 'Due soon',
    'envelopesPage.allPayments': 'All payments',
    'envelopesPage.paidToast': (p: { name: string }) => `"${p.name}" paid`,
    'envelopesPage.undo': 'Undo',
    'envelopesPage.markFailed': (p: { error: string }) => `Could not mark: ${p.error}`,
    'envelopesPage.more': (p: { n: number }) => `${p.n} more`,
    'envelopesPage.today': 'today',
    'envelopesPage.tomorrow': 'tomorrow',
    'envelopesPage.overdueBy': (p: { n: number }) => `overdue by ${p.n} ${plural(p.n, { one: 'day', other: 'days' })}`,
    'envelopesPage.markPaid': (p: { name: string }) => `Mark "${p.name}" as paid`,
    'envelopesPage.addTo': (p: { name: string }) => `${p.name}: add expense`,
    'envelopesPage.tileOver': (p: { limit: string }) => `overspent · limit ${p.limit}`,
    'envelopesPage.tileLeft': (p: { limit: string }) => `left of ${p.limit}`,
    'envelopesPage.tileNoLimit': 'spent · no limit',
    'envelopesPage.open': (p: { name: string }) => `Open envelope "${p.name}"`,
    'envelopesPage.loading': 'Loading',
  },
  be: {
    'envelopesPage.title': 'Бюджэт',
    'envelopesPage.emptyTitle': 'Канвертаў пакуль няма',
    'envelopesPage.emptyDesc': 'Канверт: катэгорыя з лімітам на перыяд, напрыклад «Прадукты», «Вёска», «Забавы».',
    'envelopesPage.emptyAction': 'Завесці першы канверт',
    'envelopesPage.envelopes': 'Канверты',
    'envelopesPage.paceMark': 'дзе павінна быць рэшта',
    'envelopesPage.noCategoryAdd': 'Без катэгорыі: дадаць трату',
    'envelopesPage.noCategoryOpen': 'Адкрыць: без катэгорыі',
    'envelopesPage.newEnvelope': 'Новы канверт',
    'envelopesPage.perDay': 'Можна траціць у дзень',
    'envelopesPage.over': 'Перарасход',
    'envelopesPage.left': 'Засталося',
    'envelopesPage.overShort': 'перарасход',
    'envelopesPage.leftShort': 'засталося',
    'envelopesPage.spentShort': 'выдаткавана',
    'envelopesPage.daysAhead': (p: { n: number }) => plural(p.n, { one: 'дзень наперадзе', few: 'дні наперадзе', many: 'дзён наперадзе', other: 'дня наперадзе' }),
    'envelopesPage.limitShort': 'ліміт',
    'envelopesPage.ahead': (p: { spent: number; days: number }) => `Траты апярэджваюць перыяд: сышло ${p.spent}% бюджэту за ${p.days}% дзён.`,
    'envelopesPage.soon': 'Хутка плаціць',
    'envelopesPage.allPayments': 'Усе плацяжы',
    'envelopesPage.paidToast': (p: { name: string }) => `«${p.name}» аплачаны`,
    'envelopesPage.undo': 'Скасаваць',
    'envelopesPage.markFailed': (p: { error: string }) => `Не ўдалося адзначыць: ${p.error}`,
    'envelopesPage.more': (p: { n: number }) => `яшчэ ${p.n}`,
    'envelopesPage.today': 'сёння',
    'envelopesPage.tomorrow': 'заўтра',
    'envelopesPage.overdueBy': (p: { n: number }) => `пратэрмінаваны на ${p.n} ${plural(p.n, { one: 'дзень', few: 'дні', many: 'дзён', other: 'дня' })}`,
    'envelopesPage.markPaid': (p: { name: string }) => `Адзначыць «${p.name}» аплачаным`,
    'envelopesPage.addTo': (p: { name: string }) => `${p.name}: дадаць трату`,
    'envelopesPage.tileOver': (p: { limit: string }) => `перарасход · ліміт ${p.limit}`,
    'envelopesPage.tileLeft': (p: { limit: string }) => `засталося з ${p.limit}`,
    'envelopesPage.tileNoLimit': 'выдаткавана · без ліміту',
    'envelopesPage.open': (p: { name: string }) => `Адкрыць канверт «${p.name}»`,
    'envelopesPage.loading': 'Загрузка',
  },
});
